<template>
  <lf-card class="mb-8 flex min-h-60 items-center justify-center">
    {{ $t("WORKFLOW.UNKNOWN_BLOCK") }}
  </lf-card>
</template>
